import React, { useEffect } from 'react';
import { PageForm } from '/src/layouts/page';
import { useLocation } from 'react-router-dom';
import UserForm from '/src/features/administration/user/components/UserForm/UserForm';
import QuotePart from '/src/components/quote/QuotePart';
function UserFormPage() {
    const location = useLocation();
    var data = null;
    var type = null;

    if (location.state != null) {
        data = location.state.data;
        type = location.state.type
    }

    return (
        <PageForm>
            <UserForm data={data} type={type} />
            <QuotePart />
        </PageForm>

    );
}
export default UserFormPage;